"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _moment = _interopRequireDefault(require("moment"));
var _getEmptyFieldValue = _interopRequireDefault(require("../../../helpers/getEmptyFieldValue.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var dateFormatByType = {
  date: 'YYYY-MM-DD',
  dateTime: 'YYYY-MM-DD hh:mm:ss A'
};
var _default = exports["default"] = function _default(values, fieldTypes, hasMatchedUser) {
  var data = {};
  var dataKeys = Object.keys(values).filter(function (k) {
    return k !== 'formHandle';
  });
  var _iterator = _createForOfIteratorHelper(dataKeys),
    _step;
  try {
    var _loop = function _loop() {
      var key = _step.value;
      var field = (0, _find2["default"])(fieldTypes, function (ft) {
        return ft.reduxFieldHandle === key;
      });
      var value = values[key];
      if (value === undefined || !field || field.type === 'coalesceField') {
        return 1; // continue
      }

      // typeof === 'object' is true for null, so we need to check for it specifically
      if (Array.isArray(value) || value !== null && _typeof(value) === 'object') {
        if (value instanceof Date) {
          var momentDate = (0, _moment["default"])(value.toUTCString());
          var dateFormat = dateFormatByType[field.displaySettings.renderAs];
          data[key] = momentDate.format(dateFormat);
        } else {
          data[key] = JSON.stringify(value);
        }
      } else {
        data[key] = value;
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }

    // gather all coalesce fields
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var coalesceFields = (0, _filter2["default"])(fieldTypes, function (f) {
    return f.type === 'coalesceField';
  });
  var newFields = {};
  coalesceFields.forEach(function (cf) {
    var value = values[cf.reduxFieldHandle];
    var hasEmptyValue = value !== (0, _getEmptyFieldValue["default"])((0, _find2["default"])(fieldTypes, function (ft) {
      return ft.reduxFieldHandle === cf.reduxFieldHandle;
    }));

    // if key doesn't exist yet in newFields
    if (!Object.keys(newFields).includes(cf.coalesceKey)) {
      // if value === empty value for field
      if (hasEmptyValue) {
        newFields[cf.coalesceKey] = Array.isArray(value) ? value : [value];
      }
    } else if (hasEmptyValue) {
      var coalesceVal = Array.isArray(value) ? value : [value];
      newFields[cf.coalesceKey] = newFields[cf.coalesceKey].concat(coalesceVal);
    }
  });
  Object.keys(newFields).forEach(function (nf) {
    data[nf] = JSON.stringify((0, _uniq2["default"])(newFields[nf]));
  });
  if (hasMatchedUser && 'username' in data) {
    delete Object.assign(data, {
      user: data.username
    }).username;
  }
  return data;
};